export const CountryCode = {
  Australia: 'AU',
  Austria: 'AT',
  Belgium: 'BE',
  Bulgaria: 'BG',
  Canada: 'CA',
  CanaryIslands: 'IC',
  Croatia: 'HR',
  Cyprus: 'CY',
  Czechia: 'CZ',
  Denmark: 'DK',
  Estonia: 'EE',
  Finland: 'FI',
  France: 'FR',
  Germany: 'DE',
  Greece: 'GR',
  Guernsey: 'GG',
  HongKong: 'HK',
  Hungary: 'HU',
  Indonesia: 'ID',
  Ireland: 'IE',
  IsleOfMan: 'IM',
  Israel: 'IL',
  Italy: 'IT',
  Japan: 'JP',
  Jersey: 'JE',
  Latvia: 'LV',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Malaysia: 'MY',
  Malta: 'MT',
  Monaco: 'MC',
  Netherlands: 'NL',
  Philippines: 'PH',
  Poland: 'PL',
  Portugal: 'PT',
  Romania: 'RO',
  Singapore: 'SG',
  Slovakia: 'SK',
  Slovenia: 'SI',
  SouthKorea: 'KR',
  Spain: 'ES',
  Sweden: 'SE',
  Switzerland: 'CH',
  Taiwan: 'TW',
  UnitedKingdom: 'GB',
  UnitedStates: 'US',
  UnitedArabEmirates: 'AE',
  Turkey: 'TR',
};

export const VcHub = {
  HK: 'HK',
  EU: 'EU',
  US: 'US',
  UK: 'UK',
};

export const CountryVcHubMap: Record<string, string> = {
  AU: VcHub.HK,
  AT: VcHub.EU,
  BE: VcHub.EU,
  BG: VcHub.EU,
  CA: VcHub.US,
  IC: VcHub.EU,
  HR: VcHub.EU,
  CY: VcHub.EU,
  CZ: VcHub.EU,
  DK: VcHub.EU,
  EE: VcHub.EU,
  FI: VcHub.EU,
  FR: VcHub.EU,
  DE: VcHub.EU,
  GR: VcHub.EU,
  GG: VcHub.UK,
  HK: VcHub.HK,
  HU: VcHub.EU,
  ID: VcHub.HK,
  IE: VcHub.EU,
  IM: VcHub.UK,
  IL: VcHub.HK,
  IT: VcHub.EU,
  JP: VcHub.HK,
  JE: VcHub.UK,
  LV: VcHub.EU,
  LT: VcHub.EU,
  LU: VcHub.EU,
  MY: VcHub.HK,
  MT: VcHub.EU,
  MC: VcHub.EU,
  NL: VcHub.EU,
  PH: VcHub.HK,
  PL: VcHub.EU,
  PT: VcHub.EU,
  RO: VcHub.EU,
  SG: VcHub.HK,
  SK: VcHub.EU,
  SI: VcHub.EU,
  KR: VcHub.HK,
  ES: VcHub.EU,
  SE: VcHub.EU,
  CH: VcHub.EU,
  TW: VcHub.HK,
  GB: VcHub.UK,
  US: VcHub.US,
  AE: VcHub.HK,
  TR: VcHub.HK,
};

export const ShippingCarrier = {
  DHL: 'DHL',
  UPS: 'UPS',
  Fedex: 'Fedex',
  CouriersPlease: 'CouriersPlease',
};

export const DISPLAY_EMPTY_VALUE = '-';
